export const createIndexList = (length: number) =>
  new Array(length).fill(0).map((_, index) => index);

export const createIndexListByArray = (array: unknown[]) =>
  array.map((_, index) => index);
